import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NoResult2(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "NoResult2", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.8583 36.5977c-.1965 0-.3849-.0781-.5238-.217l-7.4088-7.4088c-.1349-.1397-.2096-.3269-.2079-.5212.0017-.1942.0796-.38.217-.5174.1373-.1374.3232-.2153.5174-.217.1943-.0017.3814.073.5211.208l7.4088 7.4088c.1036.1036.1741.2356.2027.3793.0286.1437.0139.2926-.0421.428-.0561.1353-.151.251-.2729.3324-.1218.0814-.265.1249-.4115.1249Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.5584 35.1159c8.5927 0 15.5584-6.9658 15.5584-15.5585 0-8.5926-6.9657-15.55838-15.5584-15.55838S4 10.9648 4 19.5574c0 8.5927 6.9657 15.5585 15.5584 15.5585Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.5598 32.1517c6.9559 0 12.5949-5.6389 12.5949-12.5949 0-6.956-5.639-12.59489-12.5949-12.59489-6.956 0-12.59496 5.63889-12.59496 12.59489 0 6.956 5.63896 12.5949 12.59496 12.5949Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m34.0942 37.2844 6.0581 6.0619c.4232.4226.9967.66 1.5948.66.598 0 1.1716-.2374 1.5947-.66.4215-.423.6581-.9958.6581-1.5929s-.2366-1.1699-.6581-1.5929l-6.0619-6.0611c-.1461-.1464-.3197-.2625-.5108-.3417-.191-.0792-.3958-.12-.6027-.12-.2068 0-.4117.0408-.6027.12-.1911.0792-.3647.1953-.5108.3417l-.9632.9632c-.2934.2955-.4577.6953-.4569 1.1118.0008.4165.1668.8157.4614 1.11Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.3659 28.0287c-.1738 1.021.5131 1.9896 1.5342 2.1633 1.021.1737 1.9895-.5131 2.1633-1.5342.1737-1.021-.5132-1.9896-1.5342-2.1633-1.0211-.1737-1.9896.5132-2.1633 1.5342ZM25.8608 14.38c.0734-.4314.3933-.8208.8666-.9939.6687-.2033 1.3662.169 1.58.7761.0813.2674 2.2779 7.1089-2.0329 11.5749-.4641.4918-1.2862.4787-1.7779.0146s-.4787-1.2862-.0145-1.7779c3.2999-3.3699 1.4692-9.0078 1.4797-9.0694-.1023-.1442-.1325-.3396-.101-.5244Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.325 14.611c.6293-.6036 2.001-1.4739 3.7753-1.4739 2.2524 0 3.9009 1.5158 3.9009 3.6494 0 2.1337-1.9505 3.1583-2.328 3.3407l-.0379.7297c-.0003.1488-.0534.2914-.1477.3967-.0943.1052-.2222.1645-.3556.165H19.32c-.1335-.0004-.2613-.0597-.3557-.165-.0944-.1052-.1475-.2478-.1479-.3967l-.0879-1.7544c0-.1684.1258-.2528.3019-.3089.8431-.2666 1.5732-.828 1.5732-1.4457 0-.4912-.3273-.842-.8809-.842-.5915 0-1.2837.4069-1.7241.7858-.088.0703-.1886.1264-.2893.1264-.1636 0-.3021-.0983-.4027-.2527l-1.1074-1.7826c-.0631-.0983-.1007-.2386-.1007-.3508.0002-.1825.1008-.2946.2265-.421Zm2.391 8.9819c0-.2247.1764-.4212.3774-.4212h2.2653c.2013 0 .3775.1965.3775.4212v1.965c0 .2247-.1763.4211-.3775.4211h-2.2653c-.2011 0-.3774-.1964-.3774-.4211v-1.965Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
NoResult2.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NoResult2"
};
validateTidalLicense();
export {
  NoResult2
};
//# sourceMappingURL=NoResult2.js.map
